export default "https://zingoy-alert.herokuapp.com";
